export enum ContractActivityType {
  CREATED,
}
